export class FormatUtils {
  static formatMoney(amount: number, decimalCount = 2, decimal = '.', thousands = ',') {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? '-' : '';

    const i = parseInt(Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    const j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substring(0, j) + thousands : '') +
      i.substring(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - parseInt(i))
            .toFixed(decimalCount)
            .slice(2)
        : '')
    );
  }

  static insertSpaces = (value: number) => {
    const result = [];
    const lastDigits = `${value}`.match(/([.]\d{0,})/gi)?.[0] || '';
    const dArr = `${value}`.replace(/([.]\d{0,})/, '').split('');
    let counter = 0;
    for (let i = dArr.length; i >= 0; i--) {
      if (counter % 4 === 0 && counter !== 0) {
        result.unshift(' ');
      }
      result.unshift(dArr[i] || '');
      counter++;
    }
    return result.join('').concat(lastDigits);
  };

  static formatCardNumber = (cardNumber?: string) =>
    cardNumber
      ? cardNumber
          .split('')
          .map((digit, i) => (i % 4 === 0 ? ` ${digit}` : digit))
          .join('')
      : '';
}
